import {useDraggable} from '@dnd-kit/core';
import ProjectListItem from '../../ProjectListItem';
import ProjectOverview from '../../../models/ProjectOverview';
import clsx from "clsx";

export type DraggableProjectListItemProps = {
  project: ProjectOverview;
  isSubItem?: boolean;
  onItemClick?: () => void;
  onEditItemClick?: (project:ProjectOverview) => void
  onDuplicateItemClick?: () => void;
  onDeleteItemClick: (project: ProjectOverview) => void;
}

const DraggableProjectListItem = ({
  project,
  isSubItem = false,
  onItemClick,
  onEditItemClick,
  onDuplicateItemClick,
  onDeleteItemClick }: DraggableProjectListItemProps) => {
  const {attributes, listeners, setNodeRef, isDragging, active} = useDraggable({
    id: project.id,
    data: {
      project: project
    }
  });

  const classes = clsx('tcsp-project-list__draggable')
  
  return (
        <li className={classes} key={project.id + Date.now} ref={setNodeRef} {...listeners} {...attributes}>
          <ProjectListItem
            isActive={!!active}
            isDragging={isDragging}
            isSubItem={isSubItem}
            project={project}
            onItemClick={() => onItemClick?.call(project.id)}
            onEditItemClick={(project:ProjectOverview) => onEditItemClick?.call(this, project) }
            onDuplicateItemClick={() => onDuplicateItemClick?.call(project)}
            onDeleteItemClick={() => onDeleteItemClick(project)} />
        </li>
  );
}

export default DraggableProjectListItem;